export const PeriodColDef = ({ period }: { period: string }) => ({
    colId: period,
    field: period,
    valueGetter: (params) => {
        return params.data.values.find((value) => value.period === period)
            ?.value;
    },
    valueFormatter: ({ value }) => {
        return value
            ? new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
              }).format(value)
            : "";
    },
    resizable: false,
    sortable: false,
    minWidth: 116,
    suppressHeaderMenuButton: true,
});
